module.exports = __webpack_public_path__ + "img/Ic.47b1b7c6.png";